module.exports = __webpack_public_path__ + "assets/media/s23.30cb9504.mp3";